import { emptyApi } from '@/app/store/api/emptyApi';
import {
  ClientPromocodeControllerCalculateDiscountApiArg,
  ClientPromocodeControllerCalculateDiscountApiResponse,
  ClientPromocodeControllerExistsApiArg,
  ClientPromocodeControllerExistsApiResponse,
  ClientPromocodeControllerFindApiArg,
  ClientPromocodeControllerFindApiResponse,
} from '@/app/store/api/restApi';

export const promocodesApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getPromocodeExists: build.query<ClientPromocodeControllerExistsApiResponse, ClientPromocodeControllerExistsApiArg>({
      query: () => ({ url: `promocodes/exists` }),
    }),
    findPromocode: build.mutation<ClientPromocodeControllerFindApiResponse, ClientPromocodeControllerFindApiArg>({
      query: ({ findPromocodeDto }) => ({ method: 'POST', url: 'promocodes/find', body: findPromocodeDto }),
      invalidatesTags: ['Promocodes'],
    }),
    calculateDiscount: build.mutation<
      ClientPromocodeControllerCalculateDiscountApiResponse,
      ClientPromocodeControllerCalculateDiscountApiArg
    >({
      query: ({ calculatePromocodeDiscountDto }) => ({
        method: 'POST',
        url: 'promocodes/discount',
        body: calculatePromocodeDiscountDto,
      }),
      invalidatesTags: ['Promocodes'],
    }),
  }),
});

export const {
  useGetPromocodeExistsQuery,
  useLazyGetPromocodeExistsQuery,
  useFindPromocodeMutation,
  useCalculateDiscountMutation,
} = promocodesApi;
